import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { SupplierCreateEditProvider } from './context/supplier-create-edit-context';
import { SupplierCreateEditComponent } from './supplier-create-edit-component';

export function SupplierCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <SupplierCreateEditProvider>
                <SupplierCreateEditComponent />
            </SupplierCreateEditProvider>
        </BaseLayoutFactory>
    );
}
